<template>
  <!-- O que só vale com o lado ligado — o mínimo e o máximo do "Vários valores" — só desligado sai -->
  <ontos-choice-toggle :model-value="modelValue" :label="label" :options="[{value: false, ...off}, {value: true, ...on}]"
                       :disabled="disabled" :disabled-reason="disabledReason"
                       @update:model-value="$emit('update:modelValue', $event)">
    <template v-if="modelValue && $slots.default" #default><slot/></template>
  </ontos-choice-toggle>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import ChoiceToggle from '@/components/shared/ChoiceToggle.vue'

/** Um lado do par: o rótulo do botão, o ícone, a frase do que ele faz e — no lado ligado — a cor. */
export type PairSide = { label: string, hint: string, icon?: string, color?: string }

/**
 * Uma escolha de sim/não dita pelos dois lados — "Opcional · Obrigatório" —, no lugar da caixa de marcar
 * (ideia do usuário): a escolha de duas opções (`ChoiceToggle`), o lado desligado e o ligado.
 */
@Component({name: 'ontos-pair-toggle', emits: ['update:modelValue'], components: {'ontos-choice-toggle': ChoiceToggle}})
class PairToggle extends Vue {
  @Prop({type: Boolean, default: false}) readonly modelValue!: boolean
  @Prop({type: String, default: ''}) readonly label!: string
  @Prop({type: Object, required: true}) readonly off!: PairSide
  @Prop({type: Object, required: true}) readonly on!: PairSide
  @Prop({type: Boolean, default: false}) readonly disabled!: boolean
  @Prop({type: String, default: ''}) readonly disabledReason!: string
}

export default toNative(PairToggle)
</script>
